import type { EventWithPrice } from '~/shared/interfaces'
import type { ViewRow } from '../../model/components/index.h'

import { LiveEventCard, TopLiveEventCard } from "/app/libraries/arcana/src/blocks/Cards/LiveEventCard/index.ts"

import { useUnit } from 'effector-react'
import { useMemo } from 'react'
import { isPaid } from '~/features/payment'
import { addQuery } from '~/shared/routes'
import { $liveLabel } from '~/shared/ui/translations'
import { getCardFonts, getCollectionId, getRowType } from '../lib/style'

/**
 * The row resource is the listing event details reloads for "Also may like".
 * Events have no vod-style `categoryId`: a shelf is either a collection
 * (`collectionId`) or a status listing (`status`).
 */
export const eventDetailsListingQuery = (
  title: string,
  search: URLSearchParams | undefined
): { categoryName: string; status?: string; collectionId?: string } => ({
  categoryName: title,
  status: search?.get('status') || undefined,
  collectionId: (search ? getCollectionId(search) : '') || undefined,
})

export const EventCard = ({
  row,
  item,
  idx,
}: {
  row: ViewRow
  item: EventWithPrice
  idx: number
}) => {
  const {
    videoPosterUrl,
    videoVerticalPosterUrl,
    rented,
    name,
    id,
    labelPrice,
    isLive,
    ageRatings,
    formattedStartTime,
  } = item

  const {
    appearance: {
      style: { posterOrientation, posterSize, topContent },
      resource: { search },
      title,
    },
  } = row

  const { liveLabel } = useUnit({
    liveLabel: $liveLabel,
  })

  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? videoPosterUrl : videoVerticalPosterUrl

  const { titleFont, labelFont } = getCardFonts(posterSize)

  const Card = topContent ? TopLiveEventCard : LiveEventCard
  const topNumber = idx + 1
  const type = getRowType(row)

  const link = useMemo(
    () => addQuery(`/events/${id}`, eventDetailsListingQuery(title, search)),
    [id, title, search]
  )

  return (
    <a href={link}>
      <Card
        posterUrl={posterUrl}
        title={ageRatings}
        liveTitle={liveLabel}
        isLive={isLive}
        purchaseTitle={labelPrice}
        rented={rented}
        paid={isPaid(item)}
        titleTimeLabel={formattedStartTime}
        slidingTimeLabel
        description={name}
        descriptionFont={titleFont}
        labelFont={labelFont}
        topNumber={topNumber}
        type={type}
      />
    </a>
  )
}
